import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";
import { Map } from "../../Components/Map";

function Location() {
    const {data : {contact: {location : {data,name}}}} = useGetSettingQuery()

    return ( 
        <>
        <div className="find-location blue-bg">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <p> <i className="fas fa-map-marker-alt"></i>{name}</p>
                    </div>
                </div>
            </div>
        </div>
        {data.obj_map && <div className="embed-responsive">
            <Map lat={data.obj_map.txt_lat} lng={data.obj_map.txt_lng} name={data.obj_map.txt_name}/>
        </div>}
        </>
    );
}

export default Location;